import { z } from 'zod';
import { coSellMsftApi } from '../tackleApiClient';

const vendorSettings_Response = z
  .object({
    eligibleForDealCreation: z.boolean(),
    policiesEligibleForDealCreation: z.array(z.enum(['IPCosell'])),
    eligibleForDealRegistration: z.boolean(),
    partnerLocations: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        typeName: z.enum(['PartnerGlobal', 'PartnerLocation']),
        isUserAuthorized: z.boolean(),
        mpnId: z.string(),
      }),
    ),
    tenantId: z.string(),
  })
  .partial()
  .strict()
  .passthrough();

export const schemas = {
  vendorSettings_Response,
};

export type MsftVendorSettingsResponse = z.infer<
  typeof vendorSettings_Response
>;

/**
 * Makes a GET request to the vendor settings endpoint.
 * vendor data is picked from the bearer token
 * @param  - none.
 * @returns A promise resolving to the response adhering to the `vendorSettings_Response` schema.
 */
export async function getVendorSettings() {
  const response = await coSellMsftApi.get('api/settings/partnerCenter').json();

  const parsedResponse = vendorSettings_Response.parse(response);
  return parsedResponse;
}
